export default __webpack_public_path__ + "static/media/ticket1.18b6d00b.svg";